"use client";
import React from 'react'
import Image from 'next/image'
import { payloadImageLoader } from '@/utilities/imageLoader'

interface PayloadImageProps {
  src: string
  alt?: string
  width?: number
  height?: number
  fill?: boolean
  className?: string
  style?: React.CSSProperties
  sizes?: string
  priority?: boolean
}

/**
 * Renders an image from Payload S3 bucket using Next.js Image component.
 * Use for any image with a Payload URL (not static assets).
 */
export const PayloadImage: React.FC<PayloadImageProps> = ({
  src,
  alt = '',
  width,
  height,
  fill,
  className,
  style,
  sizes,
  priority,
}) => {
  // Defensive: If no src, render nothing
  if (!src) return null

  // If fill is true, use Next.js Image with fill prop
  if (fill) {
    return (
      <Image
        src={src}
        alt={alt}
        fill
        loader={payloadImageLoader}
        className={className}
        style={{
          objectFit: 'cover',
          ...style,
        }}
        sizes={sizes}
        priority={priority}
      />
    )
  }

  // Otherwise, use width/height
  return (
    <Image
      src={src}
      alt={alt}
      width={width || 400}
      height={height || 300}
      loader={payloadImageLoader}
      className={className}
      style={style}
      sizes={sizes}
      priority={priority}
    />
  )
}
